function initializePaymentInstallmentsModal() {
  // Find all target elements
  const targetElements = document.querySelectorAll('.multicolumn-card-wrapper-taksit');
  
  // Look for Payment Installments modal
  let paymentModal = document.querySelector('[id^="PaymentInstallmentsModal-"]');
  
  if (targetElements.length > 0) {
    // Loop through all target elements
    targetElements.forEach(function(targetElement, index) {
      // Get the data attribute
      const dataAttribute = targetElement.getAttribute('data-multicolumn-card-wrapper');
      
      if (dataAttribute) {
        // Convert to lowercase and check if it contains 'taksit'
        const lowercaseValue = dataAttribute.toLowerCase();
        const containsTaksit = lowercaseValue.includes('taksit');
        
        if (containsTaksit) {
          // Add clickable class for styling
          targetElement.classList.add('clickable');
          
          // Set up attributes for theme's built-in modal system
          targetElement.setAttribute('tabindex', '0');
          targetElement.setAttribute('role', 'button');
          targetElement.setAttribute('aria-haspopup', 'dialog');
          
          if (paymentModal) {
            targetElement.setAttribute('aria-controls', paymentModal.id);
          }
          
          // Add keyboard accessibility for Enter/Space keys
          const keydownHandler = function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              // Simulate click to trigger theme's modal system
              targetElement.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
          };
          
          // Remove existing handler if any
          if (targetElement._modalKeydownHandler) {
            targetElement.removeEventListener('keydown', targetElement._modalKeydownHandler);
          }
          targetElement._modalKeydownHandler = keydownHandler;
          targetElement.addEventListener('keydown', keydownHandler);
          
          // Add click handler to show modal content
          const clickHandler = function(e) {
            if (paymentModal) {
              // Use theme's modal system to open
              if (typeof paymentModal.show === 'function') {
                paymentModal.show();
              } else {
                // Fallback: manually set modal as open
                paymentModal.setAttribute('open', '');
                paymentModal.removeAttribute('hidden');
              }
              
              // Show the hidden content inside the modal
              const hiddenContent = paymentModal.querySelector('.product__block--payment_info, [id^="payment-installments-"]');
              if (hiddenContent) {
                hiddenContent.style.display = 'block';
              }
            }
          };
          
          if (targetElement._modalOpenHandler) {
            targetElement.removeEventListener('click', targetElement._modalOpenHandler);
          }
          targetElement._modalOpenHandler = clickHandler;
          targetElement.addEventListener('click', clickHandler);
        }
      }
    });
    
    // Set up modal close handler to hide content when modal closes
    if (paymentModal) {
      setupModalCloseHandler(paymentModal);
    }
  }
}

// Function to set up modal close handling
function setupModalCloseHandler(modal) {
  // Create a MutationObserver to watch for modal state changes
  const modalObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        // Modal was closed
        if (!modal.hasAttribute('open')) {
          const hiddenContent = modal.querySelector('.product__block--payment_info, [id^="payment-installments-"]');
          if (hiddenContent) {
            hiddenContent.style.display = 'none';
          }
        }
      }
    });
  });
  
  modalObserver.observe(modal, {
    attributes: true,
    attributeFilter: ['open']
  });
  
  // Also listen for close button clicks
  const closeButtons = modal.querySelectorAll('.drawer__close-btn, [aria-controls="' + modal.id + '"]');
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const hiddenContent = modal.querySelector('.product__block--payment_info, [id^="payment-installments-"]');
      if (hiddenContent) {
        hiddenContent.style.display = 'none';
      }
    });
  });
}

// Add CSS styles to the page
function addPaymentModalStyles() {
  const existingStyle = document.getElementById('payment-modal-styles');
  if (existingStyle) {
    return; // Styles already added
  }

  const style = document.createElement('style');
  style.id = 'payment-modal-styles';
  style.textContent = `
    .multicolumn-card-wrapper-taksit {
      cursor: pointer;
      transition: opacity 0.2s ease;
    }

    .multicolumn-card-wrapper-taksit:hover {
      opacity: 0.8;
    }

    .multicolumn-card-wrapper-taksit.clickable {
      position: relative;
    }

    /* Payment Installments Modal content styles */
    .payment-installments__modal {
      z-index: 1000;
    }

    .payment-installments__modal-content {
      color: rgb(var(--color-foreground));
    }

    .payment-installments__modal .drawer__inner {
      max-width: 50rem;
      margin: 0 auto;
    }

    .payment-installments__modal .drawer__body {
      padding: 0;
    }

    /* Ensure the hidden content displays properly when shown */
    .payment-installments__modal .product__block--payment_info {
      padding: 0;
      margin: 0;
    }
  `;
  
  document.head.appendChild(style);
}

// Track if we've already initialized to prevent multiple runs
let isInitialized = false;

// Initialize everything
function init() {
  if (isInitialized) {
    return;
  }
  
  isInitialized = true;
  addPaymentModalStyles();
  initializePaymentInstallmentsModal();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Re-initialize when content changes (for dynamic loading)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      // Check if payment installments modal was added
      const addedNodes = Array.from(mutation.addedNodes);
      const hasPaymentModal = addedNodes.some(node => 
        node.nodeType === 1 && 
        (node.querySelector && node.querySelector('[id^="PaymentInstallmentsModal-"]') || 
         node.id && node.id.startsWith('PaymentInstallmentsModal-'))
      );
      
      const hasTriggerElement = addedNodes.some(node =>
        node.nodeType === 1 &&
        (node.classList && node.classList.contains('multicolumn-card-wrapper-taksit') ||
         node.querySelector && node.querySelector('.multicolumn-card-wrapper-taksit'))
      );
      
      if (hasPaymentModal || hasTriggerElement) {
        setTimeout(init, 100); // Small delay to ensure DOM is ready
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// For Shopify theme editor compatibility
document.addEventListener('shopify:section:load', init); 